


<template>
  <div class="signOtherListTable">
    <el-table
      ref="multipleTable"
      border
      header-cell-class-name="cellCustomer  headerCellCustomer ft14"
      cell-class-name="cellCustomer ft12 cellOnly"
      :data="tableData"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="60px"></el-table-column>
      <el-table-column label="主体名称" width="196px">
        <template slot-scope="scope">{{ scope.row.name}}</template>
      </el-table-column>
      <el-table-column prop="mobile" label="手机号码" width="196px"></el-table-column>
      <el-table-column prop="mail" label="邮箱"></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      NewData: [],
      multipleSelection: []
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getCheckList() {
      return this.multipleSelection;
    }
  },
  mounted() {
    console.log(
      this.tableData + "----------------------------------------------------"
    );
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.signOtherListTable {
  margin-bottom: 20px;
  .el-table th.gutter {
    display: table-cell !important;
  }
  width: 638px;
  .cellCustomer {
    height: 48px;
    text-align: center;
    line-height: 48px;
    padding: 0;
    color: #969696;
  }
  .el-table__body-wrapper {
    max-height: 250px;
    overflow-y: auto;
  }
  .cellOnly {
    margin-left: -1px;
  }
  .headerCellCustomer {
    color: #505050;
    height: 32px;
    background-color: #f9f9f9;
  }
}
</style>
